module.exports = __webpack_public_path__ + "static/media/TrainSvgEng.6bae817e.svg";